import { render, staticRenderFns } from "./ValidationSouscripteur.vue?vue&type=template&id=55baecda&scoped=true"
import script from "./ValidationSouscripteur.vue?vue&type=script&lang=js"
export * from "./ValidationSouscripteur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55baecda",
  null
  
)

export default component.exports